module.exports = __webpack_public_path__ + "img/next-item-alt.0e10ede4.png";